import { PriceRow } from "src/api";

import { MATERIAL_DISPLAY } from "../../constants";
import { Icon } from "../icons/Icon";
import "./ItemCost.css";

export function ItemCost(props: { rows: readonly PriceRow[] }) {
  const { rows } = props;
  if (rows.length === 0) return null;

  return (
    <div className="item-cost">
      {rows.map((row, index) => {
        const display = row.material && MATERIAL_DISPLAY[row.material];
        return (
          <span className="item-cost-row" key={index}>
            <span className="item-cost-count">{row.count}</span>
            <span
              className="item-cost-material-icon"
              style={{
                backgroundColor: display?.icon
                  ? undefined
                  : (display?.color ?? "#FFFFFF")
              }}
            >
              {display?.icon && <Icon icon={display.icon} />}
            </span>
          </span>
        );
      })}
    </div>
  );
}
